/**
 * Created by ivan on 05.03.18.
 */

Field.REPLENISH_GAPS_DELAY_STEP = 0;
Field.SHUFFLE_MOVE_INTERVAL = 0.8;